import "./badge.style.scss";

import Badge from "./badge";
export default Badge;
